/** List of available agent type categories. */
export const agentTypeItems = ['salesAgent', 'externalAgent', 'supportAgent'] as const

/** Enumeration of agent types with their corresponding values. */
export enum AgentTypeEnum {
  ExternalAgent = 'externalAgent',
  SalesAgent = 'salesAgent',
  SupportAgent = 'supportAgent',
}
